import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header } from "@/components/HeaderNew";
import { HeroNew } from "@/components/HeroNew";
import { CategoriesSection } from "@/components/CategoriesSection";
import { CatalogSection } from "@/components/CatalogSection";
import { AboutCapacity } from "@/components/AboutCapacity";
import { IndustrialSection } from "@/components/IndustrialSection";
import { PartnersSection } from "@/components/PartnersSection";
import { LocationsSection } from "@/components/LocationsSection";
import { ContactSection } from "@/components/ContactSection";
import { FooterNew } from "@/components/FooterNew";
import { TechnologyPage } from "@/components/TechnologyPage";
import { ProductDetailPage } from "@/components/ProductDetailPage";
import { RetailSelectionPage } from "@/components/RetailSelectionPage";
import { OlionVracPage } from "@/components/OlionVracPage";
import { OlionBoxPage } from "@/components/OlionBoxPage";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Toaster } from "sonner";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroNew />
        <CategoriesSection />
        <AboutCapacity />
        <PartnersSection />
        <LocationsSection />
        <ContactSection />
      </main>
      <FooterNew />
    </div>
  );
};

const CatalogPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <CatalogSection />
      </main>
      <FooterNew />
    </div>
  );
};

const TechPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <TechnologyPage />
      </main>
      <FooterNew />
    </div>
  );
};

const IndustrialPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <IndustrialSection />
      </main>
      <FooterNew />
    </div>
  );
};

const ProductPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <ProductDetailPage />
      </main>
      <FooterNew />
    </div>
  );
};

const RetailPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <RetailSelectionPage />
      </main>
      <FooterNew />
    </div>
  );
};

const VracPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <OlionVracPage />
      </main>
      <FooterNew />
    </div>
  );
};

const BoxPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <OlionBoxPage />
      </main>
      <FooterNew />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogue" element={<CatalogPage />} />
            <Route path="/catalogue/:id" element={<ProductPage />} />
            <Route path="/retail" element={<RetailPage />} />
            <Route path="/olion-vrac" element={<VracPage />} />
            <Route path="/olion-box" element={<BoxPage />} />
            <Route path="/technologie" element={<TechPage />} />
            <Route path="/industriel" element={<IndustrialPage />} />
          </Routes>
          <WhatsAppFloat />
          <Toaster position="bottom-center" richColors closeButton />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
